<div class="d-flex justify-content-center align-items-center">
  @if ((currentStep$ | async) === 'RECEIVE_CODE') {
    <app-receive-code [username]="(user$ | async) ?? undefined" />
  }

  @if ((currentStep$ | async) === 'CONFIRM_CODE') {
    <app-confirm-code />
  }

  @if ((currentStep$ | async) === 'NEW_PASSWORD') {
    <app-new-password />
  }
</div>
